import React, { useEffect, useState } from 'react';
import api from '../api/client';

const PlacementModalHost: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [vacancyId, setVacancyId] = useState<string | null>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent;
      if (customEvent.detail?.vacancyId) {
        setVacancyId(customEvent.detail.vacancyId);
        setOpen(true);
      }
    };
    window.addEventListener('placement:open', handler);
    return () => window.removeEventListener('placement:open', handler);
  }, []);

  const handleConfirm = async () => {
    if (!vacancyId) return;
    try {
      await api.post(`/vacancies/${vacancyId}/placement`);
      setOpen(false);
    } catch (err) {
      console.error('Ошибка установки Placement:', err);
    }
  };

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: 16,
      }}
      onClick={() => setOpen(false)}
    >
      <div
        style={{
          background: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(20px)',
          borderRadius: 28,
          padding: 28,
          width: 480,
          maxWidth: '100%',
          boxShadow: '0 25px 50px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.6)',
          border: '1px solid rgba(255,255,255,0.5)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 16px 0', color: '#1a1a2e' }}>
          Назначить вакансии статус Placement?
        </h3>
        <p style={{ fontSize: 15, color: '#4a4a68', lineHeight: 1.5, margin: '0 0 24px 0' }}>
          Кандидат переведён в статус «Нанят». Установить статус вакансии «Placement»?
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button
            onClick={() => setOpen(false)}
            style={{
              background: 'transparent',
              border: '1px solid rgba(0,0,0,0.12)',
              borderRadius: 40,
              padding: '10px 24px',
              cursor: 'pointer',
              fontWeight: 500,
              fontSize: 14,
              color: '#666',
              transition: 'all 0.2s',
            }}
          >
            Нет
          </button>
          <button
            onClick={handleConfirm}
            style={{
              background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
              color: 'white',
              border: 'none',
              borderRadius: 40,
              padding: '10px 24px',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 14,
              boxShadow: '0 4px 12px rgba(37,117,252,0.3)',
              transition: 'all 0.2s',
            }}
          >
            Да
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlacementModalHost;
